export const Letter = ({ onClick, value, guesses, playerName }) => {
  let color = 'white';
  let backgroundColor = 'grey';

  const isUsed = [...guesses.join('')]
    .map((value) => value.toUpperCase())
    .includes(value.toUpperCase());

  let isPresent;
  let isPresentInCorrectLocation;
  guesses.forEach((guess) => {
    if (
      playerName.toUpperCase().includes(value.toUpperCase()) &&
      guess.toUpperCase().includes(value.toUpperCase())
    ) {
      isPresent = true;
      if (
        playerName.toUpperCase().indexOf(value.toUpperCase()) ===
        guess.toUpperCase().indexOf(value.toUpperCase())
      ) {
        isPresentInCorrectLocation = true;
      }
    }
  });

  if (isUsed) {
    backgroundColor = 'grey';
    color = 'black';
    if (isPresent) {
      backgroundColor = '#FFBF00';
      color = 'black';
    }
    if (isPresentInCorrectLocation) {
      backgroundColor = 'green';
      color = 'white';
    }
  }

  return (
    <span
      onClick={onClick}
      style={{
        color: color,
        padding: '5px 7px',
        margin: '5px 5px',
        backgroundColor: backgroundColor,
        borderRadius: '5px',
      }}
    >
      {value.toUpperCase()}
    </span>
  );
};
